export default __webpack_public_path__ + "static/media/Calendar.2b66ecdb.svg";